import React, { useEffect, useState } from 'react'
import MEIElectricBikesPage from 'src/pages/ReportsPages/ReportsBoard/MEIpages/MEIElectricBikesPage'
import boardReportsService from 'src/services/boardReportsService'

const MEIElectricBikesContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [table1, setTable1] = useState([])
  const [table2, setTable2] = useState([])
  const [gMei1, setGMei1] = useState([])
  const [gMei1A, setGMei1A] = useState([])
  const [gMei1B, setGMei1B] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadImports = async () => {
    const [table7, table8, gMei4, gMei5A, gMei5B] = await Promise.all([
      boardReportsService.getTotalSalesMEI('7', selectedDate.getFullYear(), 'categoria=BICICLETAS'),
      boardReportsService.getTotalSalesMEI('8', selectedDate.getFullYear(), 'categoria=BICICLETAS'),
      boardReportsService.graphicsTotalSalesMEI('4', selectedDate.getFullYear(), 'categoria=BICICLETAS&limite=5'),
      boardReportsService.graphicsTotalSalesMEI('5a', selectedDate.getFullYear(), 'categoria=BICICLETAS'),
      boardReportsService.graphicsTotalSalesMEI('5b', selectedDate.getFullYear(), 'categoria=BICICLETAS'),
    ])
    setTable1(table7)
    setTable2(table8)
    setGMei1(gMei4)
    setGMei1A(gMei5A)
    setGMei1B(gMei5B)
  }

  useEffect(() => {
    reloadImports()
  }, [])

  return (
    <MEIElectricBikesPage
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      table1={table1}
      table2={table2}
      gMei1={gMei1}
      gMei1A={gMei1A}
      gMei1B={gMei1B}
    />
  )
}

export default MEIElectricBikesContainer
